import { Alert, Box, Collapse, FormControl, InputLabel, MenuItem, Select, TextField  } from "@mui/material";

//Button
import { Button     } from "@mui/material";

//Dialog
import { Dialog,DialogActions,DialogContent,DialogContentText,DialogTitle     } from "@mui/material";

import Capa from "../../Controls/Capa/Capa";
import { getLeyendaList } from "../../../Service/leyenda";
import { useContext, useEffect, useState } from "react";
import { AuthContext } from "../../../Context/AuthContext";
import { getImageTipoList, getPosicionFirmaList } from "../../../Service/imagen";
import { addFondoImg } from "../../../Service/fdoImgService";

export default function FdoImgView(props, pInit) {

    const { accessToken } = useContext(AuthContext);
    const [leyendas, setLeyendas] = useState([]);
    const [firmas, setFirmas] = useState([]);
    const [posiciones, setPosiciones] = useState([]);
    const [loading, setLoading] = useState(false);
    const [value, setValue] = useState('')
    const [value1, setValue1] = useState('')
    const [value2, setValue2] = useState('')
    const [open, setOpen] = useState(false);
    const [valStream_id, setStream_id] = useState('')

    const [imagenes, setImagenes] = useState([]);


    let detalle = {}

    detalle = props.dataEdit

    const stream_idChange = (event) => {
        setStream_id(event.target.value);
    };
 
    //DIALOG METODOS MSJ ********************
    //Open Close
    const [openMsj, setOpenMsj] = useState(false)
    //Msj Error
    const [msjTitle, setMsjTitle] = useState("")

    const MsjElement = ({severityProp}) => {
      return (
            <Collapse in={openMsj}>
              <Alert severity={severityProp} onClose={()=>{setOpenMsj(false)}}>
                {msjTitle}
              </Alert>
            </Collapse>
          );
    };

    //DIALOG METODOS MSJ ********************

    useEffect(() => {

        setLoading(true);
        getLeyendaList(accessToken)
            .then((data) => {
                setLeyendas(data);
            })
            .catch()
            .finally(() => setLoading(false))

        setLoading(true);

        getImageTipoList(accessToken, 'L')
            .then((data) => {
                setImagenes(data);
            })
            .catch()
            .finally(() => setLoading(false))

        setLoading(true);

        getPosicionFirmaList(accessToken)
            .then((data) => {
                setPosiciones(data);
            })
            .catch()
            .finally(() => setLoading(false))

    }, []);


    const saveFondoImg = (e) => {

        e.preventDefault();

        const formData = new FormData(e.currentTarget);

        const frmInsertLogosFdoRequest = Object.fromEntries(formData);
        const datos = { frmInsertLogosFdoRequest }

        //tomo las descripciones para ser mostradas en la grilla
        //const selectedLeyenda = leyendas.find((option) => option.CodLeyenda == formData.get("CodLeyenda"))?.DescLey;
        //const selectedFirma = firmas.find((option) => option.stream_id == formData.get("stream_id"))?.Descripcion;
        //const selectedPosicion = posiciones.find((option) => option.CodImgPosicion == formData.get("CodFirmaPosicion"))?.Descripcion;

        addFondoImg(datos, accessToken)
            .then(data => {

                if(data.Message != undefined && data.Message.includes("Error")){
                    setMsjTitle(data.Message);
                    setOpenMsj(true);    
                    return;
                }else{
                    props.pInit();
                    props.handleClose();
                }
            }).catch(
                error => { 
                    setMsjTitle(error.toString());
                    setOpenMsj(true);
                }); 

    }

    return (
        
        <Box component={'form'} onSubmit={saveFondoImg}>

            <Capa onCancel={props.handleClose} title={"Fondo - Imagenes"}>
              <TextField id="outlined-basic" label="CodCafci" variant="outlined" name="CodCafci" autoComplete="off"  required />
              <br></br>
              
              

              <FormControl fullWidth required>
                    <InputLabel id="imagen-select-label">Imagen</InputLabel>
                    <Select
                        labelId="imagen-select-label"
                        id="imagen-select"
                        value={valStream_id}
                        label="Imagen"
                        onChange={stream_idChange}
                        sx={{ m: 1 }}
                        name="DescripcionImg"
                    >
                        {imagenes.map((option) => (
                            <MenuItem key={option.Descripcion} value={option.Descripcion}>
                                {option.Descripcion}
                            </MenuItem>
                        ))}
                    </Select>
                </FormControl>
              <br></br>
              <MsjElement severityProp="error"></MsjElement>   
              
            </Capa>

        </Box>
    );

};